<div class="cs_modal">
  <div class="inner-wrapper mdx_h pt_4">
    <div *ngIf="!submitSuccess">
      <p>
        Complete this form, and our team will promptly get in touch with you.
      </p>
      <div id="hubspotForm"></div>
    </div>
    <div *ngIf="submitSuccess">
      <p>
        Thank you for the submitting the information, our team will contact you
        soon.
      </p>
    </div>
  </div>
</div>
